<script>
  import Animate from '@ui/pico/animate.svelte';
  import Input from '@ui/pico/input.svelte';
  import { onMount } from 'svelte';
  import { powerupForm } from '../../../../../services';

  export let show = false;
  export let form = null;
  export let active;

  let powerup = {};
  $: configure = {};
  $: settings = powerup?.settings || {};

  onMount(() => {
    try {
      powerup = form.powerups['webforma-email-responder'] || {};
    } catch (error) {
      console.info('No powerups saved for this form');
    }
    if (settings) {
      configure.from = settings.from;
      configure.subject = settings.subject;
      configure.body = settings.body || '';
    }

    console.log({ settings, form });
  });

  async function saveConfiguration(ev) {
    const payload = {
      settings: configure,
      fid: form._id,
      puid: 'webforma-email-responder',
    };

    if (active !== undefined) {
      payload.active = active;
    }

    const resp = await powerupForm(payload);
    console.info('saveConfiguration.webforma-email-responder', resp);

    ev.target.setAttribute('data-tooltip', 'Settings updated');
    setTimeout(() => {
      ev.target.removeAttribute('data-tooltip');
    }, 2000);
  }
</script>

{#if show}
  <Animate name="fadeIn">
    <li class="configure">
      <div>
        <form on:submit|preventDefault={saveConfiguration}>
          <div class="grid">
            <Input name="from" label="From" bind:value={configure.from} />
          </div>
          <div class="grid">
            <Input name="from" label="Subject" bind:value={configure.subject} />
          </div>
          <div class="grid">
            <label>
              <span>Body</span>
              <textarea bind:value={configure.body} />
            </label>
          </div>
          <div class="grid">
            <Input type="submit" class="secondary" value="Save" />
          </div>
        </form>
      </div>
    </li>
  </Animate>
{/if}

<style>
  :global(:root) {
    --sub-bg: #eee;
    --sub-highlight: #ccc;
  }
  :global([data-theme='dark']) {
    --sub-bg: rgba(0, 0, 0, 0.3);
    --sub-highlight: #222;
  }
  textarea {
    height: 400px;
  }
  ul {
    background: var(--sub-bg);
    border-radius: 6px;
    --color: var(--contrast);
    margin: 0 1.2rem 1.2rem;
    padding: 2rem;
  }
  li {
    list-style-type: none;
  }
  li > div {
    /* background: var(--sub-highlight); */
    padding: 1.2rem;
  }
</style>
